// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__21JW0","logo":"Header_logo__HPQkP","interactiveLogo":"Header_interactiveLogo__18W_z"};